import styled from 'styled-components'

export const UpdateModeContainer = styled.div`
    .control-label {
        display: flex;
        color: ${({ theme }) => theme['gray-1000']};
        font-family: var(--font-semibold);
        .required-star {
            padding-left: 4px;
            color: ${({ theme }) => theme['red-500']};
        }
    }
`

export const UpdateMode = styled.div`
    border-top: 1px solid;
    border-bottom: 1px solid;
    border-color: ${({ theme }) => theme['gray-500']};
    padding: 24px 0 24px 0;
    width: 100%;
    margin-bottom: 24px;

    .add-escalation-button {
        margin-top: 24px;
    }

    .new-rule-button {
        margin-bottom: 24px;
    }

    .escalations {
        padding-top: 16px;
    }

    .initial-pfd-formgroup {
        margin-top: 20px;
    }

    .validation-range-help-block {
        color: ${({ theme }) => theme['red-500']};
    }

    .validation-range-formgroup,
    .new-rule-formgroup {
        display: flex;
        justify-content: space-between;

        .validation-range-formgroup-labeltext,
        .new-rule-formgroup-labeltext {
            display: flex;
            flex-direction: column;
            margin-top: 8px;
        }

        .new-rule-formgroup-labeltext,
        .validation-range-formgroup-labeltext {
            width: 78px;
            .validation-label,
            .new-rule-labels {
                font-size: 13px;
                font-weight: 400;
                padding-bottom: 5px;
                line-height: 16px;
            }
        }
    }

    .validation-range-formgroup {
        justify-content: flex-start;
        gap: 5px;
        .units {
            padding-top: 35px;
            font-size: 13px;
            font-weight: 400;
            line-height: 16px;
        }
    }

    .new-rules-formgroups {
        margin-top: 20px;
    }

    .equals {
        padding-top: 32px;
        span {
            font-weight: 900;
        }
    }

    .radio-container {
        padding-top: 32px;
        padding-bottom: 16px;
        display: flex;
        gap: 10px;
        input[type='radio'] {
            border-radius: 50%;
        }

        label {
            font-family: 'SourceSansPro-Regular';
            padding-bottom: 2px;
            font-size: 13px;
            font-weight: 400;
            line-height: 16px;
        }
    }

    .rules-trash {
        color: ${({ theme }) => theme['red-500']};
        cursor: pointer;
        padding-top: 37px;
        padding-right: 10px;
    }
    .disabled {
        color: ${({ theme }) => theme['gray-500']};
        cursor: default;
    }
`
export const Escalation = styled.div`
    width: 100%;
    display: flex;
    .form-group {
        width: 100%;
        margin: 0;
        padding-top: 24px;
    }

    .escalationfactor-ic-box {
        padding-left: 8px;
        width: 80px;
    }
    textarea {
        border-radius: 3px;
        overflow: auto;
        outline: none;

        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;

        resize: none;
    }
`

export const RemoveEscalation = styled.div`
    padding-top: 24px;
    width: 24px;
    height: 24px;
    button {
        width: 24px;
        height: 24px;
        padding: 0;
        background: transparent;
        border: none;
        color: ${({ theme }) => theme['red-500']};
    }
`
